module.exports = __webpack_public_path__ + "static/media/icon_extension_etc.6e00a22c.svg";